import { render } from "./viewMateri.vue?vue&type=template&id=43862f22"
import script from "./viewMateri.vue?vue&type=script&lang=js"
export * from "./viewMateri.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__